import type { TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField/TextField';
import MuiTextField from '@mui/material/TextField/TextField';
import type { FC, MouseEvent } from 'react';
import { useState } from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, InputAdornment } from '@mui/material';

export type TextFieldProps = MuiTextFieldProps & {
  name: string;
};

export const TextField: FC<TextFieldProps> = props => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const isPassword = props.type === 'password';

  const handleClickShowPassword = () => setIsPasswordVisible(show => !show);
  const handleMouseDownPassword = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  return (
    <MuiTextField
      {...props}
      type={isPassword ? (isPasswordVisible ? 'text' : 'password') : props.type}
      InputProps={{
        ...props.InputProps,
        endAdornment: isPassword ? (
          <InputAdornment position='end'>
            <IconButton
              aria-label='toggle password visibility'
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge='end'
            >
              {isPasswordVisible ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ) : (
          props.InputProps?.endAdornment
        ),
      }}
    />
  );
};
